// src/legal/Value.jsx
// An operator-supplied value on a legal page, or a highlighted [TO CONFIRM] marker when
// this deployment has not set it (legalConfig.js). `mail` renders an address as mailto.

import React from 'react';

export default function Value({ v, mail = false }) {
  if (v.missing) return <span className="lg-missing">{v.text}</span>;
  if (mail) return <a href={`mailto:${v.text}`}>{v.text}</a>;
  return <>{v.text}</>;
}
